import Webamp from 'webamp';

const startWebamp = () => {
    if (Webamp.browserIsSupported()) {
        const webamp = new Webamp({
            initialTracks: [
                {
                    metaData: {
                        artist: "Arctic Monkeys",
                        title: "505"
                    },
                    url: `${process.env.PUBLIC_URL}/Arctic Monkeys - 505.mp3`,
                    duration: 253
                },
                {
                    metaData: {
                        artist: "The Handsome Family",
                        title: "Far From Any Road"
                    },
                    url: `${process.env.PUBLIC_URL}/The Handsome Family - Far From Any Road.webm`,
                    duration: 168
                },
                {
                    metaData: {
                        artist: "Barns Courtney",
                        title: "Fire"
                    },
                    url: `${process.env.PUBLIC_URL}/Barns Courtney - Fire.webm`,
                    duration: 198
                },
                {
                    metaData: {
                        artist: "KALEO",
                        title: "I Can't Go On Without You"
                    },
                    url: `${process.env.PUBLIC_URL}/KALEO - I Cant Go On Without You.webm`,
                    duration: 334
                }
            ]
        });
        webamp.onClose(() => {
            webamp.dispose();
        });

        webamp.renderWhenReady(document.getElementById('winamp-container'));
    }
};

export { startWebamp };